import { Checkbox, Typography } from "antd";
import React from "react";
import { Controller } from "react-hook-form";

const ControlledCheckbox = ({
  name,
  control,
  checked,
  label,
  className,
  defaultValue
}) => (
  <Controller
    name={name}
    control={control}
    render={({ field }) => (
      <Checkbox
        defaultChecked={defaultValue}
        className={className}
        checked={checked ?? field.value}
        onChange={(e) => {
          field.onChange(e);
        }}
      >
        <Typography.Text>{label}</Typography.Text>
      </Checkbox>
    )}
  />
);

export default ControlledCheckbox;
